import React from 'react'
import { HostServices } from '@ally/federated-types'
import { HostData } from '@ally/data-types-host'
import { noop } from './utils'

export const defaultHostServices = (): HostServices =>
  ({
    hostData: {} as HostData,
    log: {
      track: noop,
      log: noop,
      error: noop,
      warn: noop,
      info: noop,
      debug: noop,
      trace: noop,
      child: noop,
    },
  } as HostServices)

export const HostServicesContext = React.createContext<HostServices>(
  defaultHostServices(),
)

export function useHostServices(): HostServices {
  return React.useContext(HostServicesContext)
}
